export default __webpack_public_path__ + "2d81cf808e0435e70cee4484b322cdfa.svg";